let isLoading = false;
let isLoaded = false;
let callbacks = [];

export function loadGoogleMaps(callback) {
  if (isLoaded && window.google && window.google.maps) {
    callback();
    return;
  }

  callbacks.push(callback);

  if (isLoading) {
    return;
  }

  isLoading = true;
  const script = document.createElement("script");
  script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&v=weekly`;
  script.async = true;

  script.onload = () => {
    isLoaded = true;
    isLoading = false;
    callbacks.forEach((cb) => cb());
    callbacks = [];
  };

  script.onerror = (error) => {
    console.error("Error loading Google Maps:", error);
    isLoading = false;
    callbacks = [];
  };

  document.body.appendChild(script);
}
